import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography, Paper, Divider, Box } from "@mui/material";
import { ReactComponent as CloseIcon } from '../../assets/images/CloseIcon.svg';
import backgroundImg from '../../assets/images/circleBackground.png';
import { ReactComponent as Success } from '../../assets/images/Success.svg';
import { ReactComponent as Creation } from '../../assets/images/Creation.svg';
import { Navigate, useNavigate   } from "react-router-dom";
import { ReactComponent as TickMark } from '../../assets/images/TickMark.svg';
import {automationHttpRequest} from "../../api/httpRequests";

const PartCreationSuccess = ({ partCreationDialog, setPartCreationDialog, requestID }) => {
    const navigate = useNavigate ();

    const handleClose = () => {
        setPartCreationDialog(false)
        navigate("/dashboard");

    };

    return (
        <>
            <Dialog
                open={partCreationDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                    sx: {
                        maxWidth: "1000px",
                        borderRadius: "10px"
                    }
                }}
            >
                <DialogTitle sx={{ display: "flex", justifyContent: "flex-end", margin: "10px" }}>
                    {/* <Creation /> */}
                    {/* <Typography sx={{ fontFamily: "Verdana", fontSize: "24px", fontWeight: "700", lineHeight: "21px" }}>
                       Part Creation Request
                    </Typography> */}
                    <CloseIcon style={{ cursor: "pointer" }} onClick={handleClose} />
                </DialogTitle>
                <DialogContent sx={{ width: "1000px",height:"400px" }}>
                    <DialogContentText id="alert-dialog-description">
                        <div>
                            {/* <div style={{
                                // backgroundImage: `url(${backgroundImg})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                width: '50%',
                                height: '300px',
                                margin: "auto"
                            }}>
                            </div> */}
                            <Box
                                sx={{
                                    // display: 'flex',
                                    // flexWrap: 'wrap',
                                    m: 1,
                                    width: "100%",
                                    borderRadius: "18px",
                                    height: 180,
                                    margin: "auto",
                                    zIndex: 100,
                                    position: "relative",
                                    top: "100px"
                                    // top: "-300px"
                                    // '& > :not(style)': {
                                    //     m: 1,
                                    //     width: "80%",
                                    //     borderRadius: "18px",
                                    //     height: 180,
                                    //     margin: "auto",
                                    //     zIndex: 100,
                                    //     position: "relative",
                                    //     // top: "-300px"
                                    // },
                                }}
                            >
                                <Paper elevation={0}>
                                    <div>
                                        <div style={{ display: "flex", alignItems: "center", height: "80px", justifyContent: "center" }}>
                                            <TickMark style={{ height: "60px" }} />
                                            <Typography sx={{ fontSize: "24px", fontWeight: "500" }}>New Part Request Submitted Successfully</Typography>
                                        </div>
                                        {/* <Divider /> */}
                                        <div>
                                            <Typography sx={{ fontSize: "24px", margin: "20px auto", borderRadius: "8px", width: "35%", padding: "10px" }}> Request ID: # {requestID} </Typography>
                                        </div>
                                    </div>
                                </Paper>
                            </Box>
                        </div>
                    </DialogContentText>
                </DialogContent>
                {/* <DialogActions>
                    <Link to="dashboard">  
                     <button
                        type="submit"
                        className="submitButton"
                        style={{
                            fontSize: 16,
                            cursor: "pointer",

                            position: "relative",
                            fontFamily: "Verdana",
                        }}
                        onClick={(e) => {
                            e.preventDefault();
                            handleClose()
                            navigate('/dashboard')
                        }}
                    >
                        Close
                    </button>
                    </Link>
                </DialogActions> */}
            </Dialog>
        </>
    );
}

export default PartCreationSuccess;




